import type { FieldInputProps, FormikProps } from 'formik'
import { Field } from 'formik'

import { FIELD_SIZES } from '../../config/constants'
import type { FieldConfig, FieldSize, FormValues } from '../Form/Form.types'

import Select from './Select'

function FormikSelectField({
  field,
  errors,
}: {
  field: FieldConfig
  errors: FormikProps<FormValues>['errors']
}) {
  return (
    <Field name={field.name}>
      {({
        field: { value },
        form: { setFieldValue },
        meta,
      }: {
        field: FieldInputProps<string>
        form: FormikProps<FormValues>
        meta: { error?: string }
      }) => (
        <Select
          value={value}
          options={field.options ?? []}
          size={(field.size as FieldSize) ?? FIELD_SIZES.MEDIUM}
          isLoading={field.isLoading}
          error={Boolean(meta.error && errors[field.name])}
          onChange={(val) => setFieldValue(field.name, val)}
          onFocus={field.onFocus}
        />
      )}
    </Field>
  )
}

export default FormikSelectField
